import Axios from 'axios'
// import { Message } from 'element-ui'
// import { getCookies } from '@/utils/auth'
// 创建axios 实例
const service = Axios.create({
  baseURL: '', // api的baseurl
  timeout: 222222 // 请求超时时间
})

export default service



// WEBPACK FOOTER //
// ./src/api/http.js